export default __webpack_public_path__ + "2e93dac2287f787bf87ec98e8ada693b.jpg";